<div class="my-roche-banner ui-label-s" *ngIf="allowToShow$ | async">
  <span>Discover the new intranet: myRoche (beta mode)</span>
    <button rds-primary-button class="switch-btn" (click)="goOutside()" style="min-width: 168px;">Switch to myRoche</button>
</div>

